import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=e0750bca&scoped=true&"
import script from "./MessagesView.vue?vue&type=script&lang=ts&"
export * from "./MessagesView.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=e0750bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0750bca",
  null
  
)

export default component.exports